import React from 'react';
import PropTypes from 'prop-types';
// Models
import mInstallationAsyncOperation from 'models/installationAsyncOperation';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { dateGenerator } from 'utils/DateUtils';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import DateFilter from 'components/filters/DateFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';

const AsyncOperationFilters = ({
  timezone, disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    begin, end, resourceType, status,
  } = filters;
  // Dates
  const beginDate = dateGenerator.dateFromTimezone(begin.value, timezone);
  const endDate = dateGenerator.dateFromTimezone(end.value, timezone);

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0 pb-3">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {isFieldDisplayable('begin') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.afterDate"
              type="begin"
              value={beginDate}
              onChange={(value) => onFilterFieldChange('begin', value)}
            />
          </div>
        )}
        {isFieldDisplayable('end') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.beforeDate"
              type="end"
              value={endDate}
              onChange={(value) => onFilterFieldChange('end', value)}
            />
          </div>
        )}
        {isFieldDisplayable('resourceType') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.resourceType"
              value={resourceType.value}
              items={mInstallationAsyncOperation.resourceTypesList}
              onChange={(value) => onFilterFieldChange('resourceType', value)}
            />
          </div>
        )}
        {isFieldDisplayable('status') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.result"
              value={status.value}
              items={mInstallationAsyncOperation.statusesList}
              onChange={(value) => onFilterFieldChange('status', value)}
            />
          </div>
        )}
      </div>
    </FiltersTemplate>
  );
};

AsyncOperationFilters.propTypes = {
  timezone: PropTypes.string.isRequired,
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    begin: listFilterShape,
    end: listFilterShape,
    resourceType: listFilterShape,
    status: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(
  mInstallationAsyncOperation.listFeatures.searchFields,
)(AsyncOperationFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/asyncOperations/AsyncOperationFilters.js